import React, { useEffect, useState } from 'react'
import TemplateTable from 'component/Templates/TemplateTable'
import TemplatesHeader from 'component/Templates/TemplatesHeader'
import { useAppDispatch } from 'hooks/reduxHooks'
import { clearTemplates } from 'slices/template'

interface TempaltePageLayoutProps {
	client?: string
}

const TemplatesPageLayout: React.FC<TempaltePageLayoutProps> = ({
	client = undefined,
}) => {
	const dispatch = useAppDispatch()

	const [status, setStatus] = useState('')

	const handleSelect = (value: string) => {
		setStatus(value)
	}

	useEffect(() => {
		return () => {
			dispatch(clearTemplates())
		}
	}, [])

	return (
		<>
			<TemplatesHeader onSelect={handleSelect} />
			<TemplateTable selectedStatus={status} client={client} />
		</>
	)
}

TemplatesPageLayout.defaultProps = {
	client: undefined,
}

export default TemplatesPageLayout
